<template>
<div class="chapter">
<div class="inner_page">
<p class="htitle"><a id="page_i"></a><span class="bold">StuG III Brigade 191, 1940–1945</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Halftitle.vue?7d372240